<template>
    <template v-if="hasRaffleDataLoadingFailed">
        <div class="bonusomat-raffle-counters__counter-box bonusomat-raffle-counters__counter-box--failed">
            <div class="bonusomat-placeholder">
                <div class="bonusomat-placeholder__text">Při načítání losovačky nastala chyba</div>
                <div class="bonusomat-placeholder__subtext">Zkuste to prosím později</div>
            </div>
        </div>
    </template>
    <template v-else>
        <div
            v-if="showDefaultCounters"
            class="bonusomat-raffle-counters__counters-group bonusomat-raffle-counters__counters-group--default"
        >
            <div
                class="bonusomat-raffle-counters__counter-box bonusomat-raffle-counters__counter-box--main"
                :class="{ 'bonusomat-raffle-counters__counter-box--highlighted': !isWidget }"
            >
                <div class="bonusomat-raffle-counters__counter-box__title">Aktuálně hrajeme o celkem</div>
                <BonusomatCounter :counterValue="totalWin ?? 0" :numeral-count="6" unit="Kč" :is-widget="isWidget" />
            </div>
            <div class="bonusomat-raffle-counters__counter-box bonusomat-raffle-counters__counter-box--draw-counter">
                <div class="bonusomat-raffle-counters__counter-box__title">Slosování za</div>
                <TimeCounter :remainingSeconds="raffleRemainingSeconds" />
            </div>
            <div
                class="bonusomat-raffle-counters__counter-box bonusomat-raffle-counters__counter-box--ticket-counter"
                v-if="showTicketsCounters"
            >
                <div class="bonusomat-raffle-counters__counter-box__title">Vaše tikety</div>
                <BonusomatCounter :counterValue="raffleTicketsCount ?? 0" :numeral-count="2" />
            </div>
        </div>
        <div
            v-if="showAllwynCounters"
            class="bonusomat-raffle-counters__counters-group bonusomat-raffle-counters__counters-group--allwyn"
        >
            <AllwynHeadingBox :name="allwynName" />
            <div class="bonusomat-raffle-counters__counter-box bonusomat-raffle-counters__counter-box--draw-counter">
                <div class="bonusomat-raffle-counters__counter-box__title">Slosování za</div>
                <TimeCounter :remainingSeconds="allwynRemainingSeconds" />
            </div>
            <div
                class="bonusomat-raffle-counters__counter-box bonusomat-raffle-counters__counter-box--ticket-counter"
                v-if="showTicketsCounters"
            >
                <div class="bonusomat-raffle-counters__counter-box__title">Vaše tikety</div>
                <BonusomatCounter :counterValue="allwynTicketsCount ?? 0" :numeral-count="2" />
            </div>
        </div>
    </template>
</template>

<script lang="ts" setup>
import AllwynHeadingBox from "../raffle/allwyn-heading-box.vue";
import TimeCounter from "../raffle/time-counter.vue";
import BonusomatCounter from "../shared/bonusomat-counter.vue";

defineProps<{
    hasRaffleDataLoadingFailed: boolean;
    showDefaultCounters?: boolean;
    totalWin: number;
    raffleRemainingSeconds: number;

    showAllwynCounters?: boolean;
    allwynName?: string;
    allwynRemainingSeconds?: number;

    showTicketsCounters?: boolean;
    raffleTicketsCount?: number;
    allwynTicketsCount?: number;

    isWidget?: boolean;
}>();
</script>
